import objectFitImages from 'object-fit-images';
import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import 'cookieconsent';

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/typo3conf/ext/sfsitepackage/Resources/Public/';
}

// link focus
// fix for problem described here https://axesslab.com/skip-links/
// taken from https://github.com/selfthinker/dokuwiki_template_writr/blob/master/js/skip-link-focus-fix.js
jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector){
        const $element = $(el);
        return $element.is(':input:enabled, a[href], area[href], object, [tabindex]') && !$element.is(':hidden');
    }
});

LinkFocusHelper.handleHashLink();

/**
 * Iterate over all dom nodes with attribute "data-component" and use it's value to dynamically import the
 * corresponding component
 */
function initComponents(parentNode = document) {
    for (const node of parentNode.querySelectorAll('[data-component]')) {
        const componentPath = ComponentHelper.prepareComponentPath(node.getAttribute('data-component'));

        if (typeof componentPath !== 'string') {
            continue;
        }

        import(`./components/${componentPath}`).then((Component) => {
            const comp = new Component.default(node);
            comp.init();
        }).catch((e) => console.info(e.message));
    }
}
/* eslint-enable */

$(window).on('load', () => {
    window.youtubePlayers = [];
    initComponents();

    objectFitImages();

    const pageHeader = document.querySelector('.page-header');
    window.cookieconsent.initialise({
        content: {
            message: pageHeader.getAttribute('data-cookie-consent-message'),
            dismiss: pageHeader.getAttribute('data-cookie-consent-dismiss'),
            link: pageHeader.getAttribute('data-cookie-consent-link'),
            href: pageHeader.getAttribute('data-cookie-consent-href'),
        },
    });
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
